<template>
	<div class="oxConBox">
		<!-- 标题 -->
		<p class="pageTitle">
			订单详情
		</p>
		<!-- 订单信息模块 -->
		<div class="oXorderBox">
			<!-- 标题 -->
			<ul class="oXorderBox-titBox d-rn d-aic d-jcs">
				<li>商品信息</li>
				<li>商品属性</li>
				<li>单价</li>
				<li>数量</li>
				<li>优惠券</li>
				<li>快递费</li>
				<li>小计</li>
			</ul>
			<!-- 商品信息 -->
			<div class="oXorderBox-orderList">
				<!-- 商品信息 -->
				<ul :class="['oXorderBox-orderList-itemUlBox','d-rn','d-ais','d-jcs']"
				v-for="(item,index) in pageshopList" :key='index'>
					<!-- 商品图片 -->
					<img class="oXorderBox-orderList-itemImgBox" :src="item.goods_attr_img" >
					<!-- 商品名称/备注 -->
					<li class="oXorderBox-orderList-itemNameBzBox d-cw d-ais d-jcb">
						<!-- 商品名称 -->
						<p class="txt-cut">
							{{item.goods_title}}
						</p>
						<!-- 商品备注 -->
						<p class="one-txt-cut">
							备注：{{bzInfoTxt||item.order_main_remarks}}
						</p>
					</li>
					<!-- 商品属性 -->
					<li class="oXorderBox-orderList-itemAttribute d-cw d-ais d-jcs">
						<p class="one-txt-cut">{{item.modul_name}}：{{item.parent_title}}</p>
						<p class="one-txt-cut">{{item.good_attr_modular_name}}：{{item.goods_attr_title}}</p>
					</li>
					<!-- 单价 -->
					<li class="oXorderBox-orderList-itemShopPrice one-txt-cut">
						￥{{item.trader_goods_money}}
					</li>
					<!-- 数量 -->
					<li class="oXorderBox-orderList-itemShopNum one-txt-cut">
						{{item.back_num}}
					</li>
					<!-- 优惠券 -->
					<li class="oXorderBox-orderList-itemShopCoupup">
						无
					</li>
					<!-- 快递费 -->
					<li class="oXorderBox-orderList-itemShopKdF">
						{{shopYfPrice?(shopYfPrice-0).toFixed(2):'包邮'}}
					</li>
					<!-- 小计 -->
					<li class="oXorderBox-orderList-itemShopXj one-txt-cut">
						￥{{(((item.trader_goods_money-0)*100)*item.back_num/100).toFixed(2)}}
					</li>
					
				</ul>
				<!-- 总价 -->
				<ul class="oXorderBox-orderList-shopAllPrice">
					<template v-if="actualPrice2">
						总计：{{actualPrice2?(Number(actualPrice2).toFixed(2)):'0.00'}}
					</template>
					<template v-else>
						总计：{{orderInfo&& orderInfo>=0?(orderInfo.orderCouponSum-0).toFixed(2):shopAllPrice && shopAllPrice>=0?shopAllPrice:'0.00'}}
					</template>
				</ul>
			</div>
		</div>
		<!-- 支付标题 -->
		<p class="oxqPayTit">
			请选择支付方式
		</p>
		<!-- 支付方式选择 -->
		<ul class="oxqPayTypeSel d-rn d-aic d-jcs" >
			<li class="d-rn d-aic d-jcs showHand" @click="throttle(handleZfbPayEvent,1500,false)">
				<img src="../../assets/img/privacy/icon-zfb.png" >
				<p>支付宝支付</p>
			</li>
			<li class="d-rn d-aic d-jcs showHand" @click="throttle(handleWxPayEvent,1500,true)">
				<img src="../../assets/img/privacy/icon-wx.png" >
				<p>微信支付</p>
			</li>
		</ul>
		
	</div>
</template>

<script>
	import {
		// appUserFindByOrerInfo				//总订单
		appUserFindByBackstageInfo,			//子订单
		// appUserByBackstageOrOrder,			//判断子订单还是总订单
		// appCBackstageAndOrderUpAddres		//订单地址修改接口
	} from '@/api/order.js';
	import { 
		appUserPayOrder,//支付总订单
		appUserPayBackstage,//支付子订单
		appUserFindByOrerInfo//总订单详情
	} from '@/api/orderXq.js'
	import {
		selByList,		//地址信息
		getAppCCartByIds,	//id查询商品信息
		yHselByList,	//优惠券
		getFreightByAddress,//运费计算
	} from '@/api/submitOrder.js'
	let _self;
	export default {
		name: 'OrderXq',
		data() {
			return {
				// 当前页面支付方式
				currentPayType:null,
				// 用户信息
				userInfo:null,
				// 商品id集合
				seeShopId:null,
				// 商品列表
				pageshopList:null,
				
				
				
				// 总订单
				// 订单信息===总订单来自上页面的下单信息
				orderInfo:null,
				// 优惠券信息
				pageshopCoupup:null,
				// 运费信息
				shopYfPrice:null,
				// 备注信息
				bzInfoTxt:null,
				// 总价格
				shopListAllPrice:0,
				
				
				// 子订单
				// 子订单信息
				sonOrderInfo:null,
				// 子订单id
				sonOrderId:null,
				// 总金额
				shopAllPrice:null,
				// 子订单详情orderBackInfo信息
				shopPriceInfo:null,
				
				
				// 微信订单号
				wxOrderCode:null,
				// 接口请求状态
				isRequestState:false,
				
				// 折扣价格
				actualPrice2:null
			}
		},
		beforeCreate() {
			_self=this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			this.$EventBus.$emit('AppCloseNav', true);
			
			// 判断页面传参信息
			try{
				// 解码获取的路由参数
				let pageVal=decodeURIComponent(_self.$router.history.current.query.info);
				// json化数据
				let jxVal=JSON.parse(pageVal || '{}');
				// 判断页面是否有传值信息
				if(pageVal && jxVal && jxVal.pagesId){
					console.log('页面传递参数===',jxVal);
					// 定义当前定制支付方式====payType:1总订单2子订单
					_self.currentPayType=jxVal.type==1?1:2;
						
					// 总订单信息↓
					if(_self.currentPayType==1){
						// 定义订单信息
						_self.orderInfo=jxVal.orderInfdo;
						// 定义运费信息
						_self.shopYfPrice=jxVal.freightMoney;
						// 备注信息
						_self.bzInfoTxt=jxVal.bzInfo;
						// 折扣价格
						_self.actualPrice2=jxVal.actualPrice2;
						// 查询商品详情
						_self.handleGetOrderInfo();
					}else{
						// console.log('查询子订单===',);
						
						// 定义子订单信息
						_self.sonOrderInfo=jxVal.orderInfdo;
						// 定义子订单id
						_self.sonOrderId=jxVal.pagesId;
						// 查询子订单信息
						_self.handleSearchSonOrder();
					}
				}else{
					_self.$eror('商品信息错误！')
					// 无页面传值===返回首页
					_self.$router.replace({name:'ShopCar'});
				}
			}catch(err){
				_self.$eror('商品信息错误。')
				// 出现错误的情况下===》跳转回首页
				_self.$router.replace({name:'ShopCar'});
			}
		},
		methods: {
			// 获取总订单===所有商品信息
			handleGetOrderInfo(){
				appUserFindByOrerInfo({
					orderId:_self.orderInfo.orderId
				}).then(res=>{
					// console.log('订单信息====》',res);
					
					if(res.code==200){
						// 判断订单类型===总==currentPayType=1/子==currentPayType=2
						// 定义微信订单号
						_self.wxOrderCode=res.data.orderInfo.orderNumber;
							
						// 定义总价格
						_self.shopAllPrice=res.data.orderInfo.orderSum;
						// 定义页面订单列表信息
						_self.pageshopList=res.data.goods;
						// 定义使用的优惠券信息
						_self.pageshopCoupup=res.data.coupon;
						// 计算商品总价
						_self.handleJsAllShopPrice();
					}else{
						_self.$router.replace({name:'Home'});
					}
				}).catch(err=>{
					_self.$router.replace({name:'Home'});
				})
			},
			// 查询子订单信息
			handleSearchSonOrder(){
				appUserFindByBackstageInfo({
					backId:_self.sonOrderId
				}).then(res=>{
					// console.log('子====订单信息===',res);
					if(res.code==200){
						// 订单当前页面订单信息
						
						// 定义微信商户订单号
						_self.wxOrderCode=res.data.orderBackInfo.backNumber;
						// 定义总价信息
						_self.shopPriceInfo=res.data.orderBackInfo;
						// 定义邮费价格
						_self.shopYfPrice=res.data.orderBackInfo.backFreight;
						// 定义商品列表
						_self.pageshopList=res.data.goods;
						
						// 定义总价格
						_self.shopAllPrice=res.data.orderBackInfo.backPayPaidMoney;
					}else{
						_self.$router.replace({name:'Home'})
					}
				}).catch(err=>{
					_self.$router.replace({name:'Home'})
				})
			},
			// 计算商品总价
			handleJsAllShopPrice(){
				// 定义初始总价
				let csAllPrice=0;
				// 循环商品列表
				_self.pageshopList.forEach((itt,ixx)=>{
					csAllPrice=csAllPrice+((itt.trader_goods_money*100)*itt.back_num);
				})
				// console.log('总价===优惠券前',csAllPrice);
				// 判断是否选择了优惠券
				if(_self.pageshopCoupup){
					// 定义优惠券的价格
					let coupupPrice=(_self.pageshopCoupup.couponAmount-0)*100;
					csAllPrice=csAllPrice-coupupPrice;
				}
				// console.log('总价===优惠券后',csAllPrice);
				// 定义总价格
				_self.shopListAllPrice=csAllPrice>=0?csAllPrice/100:0;
			},
			
			
			
			// 微信支付
			handleWxPayEvent(type){
				// 防止频繁支付
				if(_self.isRequestState){
					_self.$jgTips('正在请求中，请稍等！');
					return false;
				}
				_self.isRequestState=true;
				
				// console.log('开始==微信支付====');
				// 定义接口参数
				let rstData={};
				// 参数定义
				rstData.type=3;
				rstData.payType=1;
				let pageId;
				if(_self.currentPayType==1){
					// 总订单===购物车
					
					// 接口需求参数
					rstData.orderId=_self.orderInfo.orderId;
					
					// 定义页面传参
					pageId={
						rstData:rstData,
						orderId:_self.orderInfo.orderId,
						orderType:true,	//总订单
						orderCode:_self.wxOrderCode,
						yfPrice:_self.actualPrice2
					};
				}else{
					// 子订单===订单详情
					
					// 接口需求参数
					rstData.backId=_self.shopPriceInfo.backId;
					
					// 定义页面传参
					pageId={
						rstData:rstData,
						orderId:_self.shopPriceInfo.orderId,
						orderType:false,	//总订单
						orderCode:_self.wxOrderCode,
						// 应付价格
						yfPrice:_self.shopPriceInfo.backPayPaidMoney
					};
				}
				// console.log('子订单微信支付====》传递参数',pageId);
				// 编码encodeURIComponent() ||  解码decodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify(pageId));
				// 不保存当前页面跳转==传递下一页信息
				_self.$router.replace({name:'OrderPay',query:{info:pageVal}})
			},
			// 支付宝支付
			handleZfbPayEvent(type){
				// 防止频繁点击
				if(_self.isRequestState){
					_self.$jgTips('正在请求中，请稍等！');
					return false;
				}
				_self.isRequestState=true;
				
				// console.log('开始==支付宝支付====');
				// 定义接口参数
				let rstData={
					type:4,
					payType:2,
				};
				if(_self.currentPayType==1){
					// 总订单===orderId
					rstData.orderId=_self.orderInfo.orderId;
					
					// 支付宝===总订单
					appUserPayOrder(rstData).then(res=>{
						// console.log('总订单===订单返回信息===',res);
						
						
						if(res.data=='0元支付' && res.code==200){
							// 挑战到支付成功页面
							_self.$router.replace({name:'OrderPaySuc'})
						}else if(res.code==200){
							// 编码encodeURIComponent() ||  解码decodeURIComponent()
							let pageVal=encodeURIComponent(JSON.stringify(res.data.body));
							// 不保存当前页面跳转==传递下一页信息
							_self.$router.replace({name:'ZfbPay',query:{info:pageVal}})
						}
					}).finally(err=>{
						// 允许再次请求
						_self.isRequestState=false;
					})
				}else{
					// 子订单===backId
					rstData.backId=_self.shopPriceInfo.backId;
					
					// 支付宝===子订单
					appUserPayBackstage(rstData).then(res=>{
						// console.log('子订单===订单返回信息===',res);
						if(res.data=='0元支付' && res.code==200){
							// 挑战到支付成功页面
							_self.$router.replace({name:'OrderPaySuc'})
						}else if(res.code==200){
							// 编码encodeURIComponent() ||  解码decodeURIComponent()
							let pageVal=encodeURIComponent(JSON.stringify(res.data.body));
							// 不保存当前页面跳转==传递下一页信息
							_self.$router.replace({name:'ZfbPay',query:{info:pageVal}})
						}
					}).finally(err=>{
						// 允许再次请求
						_self.isRequestState=false;
					})
				}
			},
		},
		// 组件
		components: {

		},
		// 计算
		computed: {

		},
		beforeRouteEnter(to, from, next) {
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
		
		beforeMount() {

		},
		mounted() {
			document.body.style.background='#F5F5F5';
			
			// 滚动到头部
			window.scrollTo({
				left: 0,
				top: 0,
			});
		},
		destroyed() {

		}
	}
</script>
<style lang="scss">
	/* 页面整体 */
	.oxConBox{
		width: 1200px;
		min-height: 750px;
		margin: 0 auto;
	}
	/* 页面标题 */
	.pageTitle{
		padding: 30px 0 20px;
		box-sizing: border-box;
		width: 100%;
		
		font-size: 24px;
		font-weight: 400;
		text-align: left;
		color: #000000;
		letter-spacing: 3px;
	}
	/* 订单模块 */
	.oXorderBox{
		width: 100%;
		background: #FFFFFF;
		/* 标题 */
		&-titBox{
			width: 100%;
			padding: 20px 0 19px ;
			box-sizing: border-box;
			li{
				font-size: 16px;
				font-weight: 400;
				color: #333333;
				letter-spacing: 2px;
			}
			li:nth-of-type(1){
				margin-left: 124px;
			}
			li:nth-of-type(2){
				margin-left: 260px;
			}
			li:nth-of-type(3){
				margin-left: 130px;
			}
			li:nth-of-type(4){
				margin-left: 60px;
			}
			li:nth-of-type(5){
				opacity: 0;
				margin-left: 60px;
			}
			li:nth-of-type(6){
				margin-left: 60px;
			}
			li:nth-of-type(7){
				margin-left: 80px;
			}
		}
		/* 订单列表 */
		&-orderList{
			width: 100%;
			/* 每个商品盒子 */
			&-itemUlBox{
				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				border: 1px solid #e5e5e5;
			}
			/* 商品图 */
			&-itemImgBox{
				width: 80px;
				height: 80px;
			}
			/* 商品名称/备注 */
			&-itemNameBzBox{
				width: 240px;
				margin-left: 20px;
				height: 80px;
				p:nth-of-type(1){
					margin-top: 6px;
					width: 100%;
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #333333;
					letter-spacing: 2px;
				}
				p:nth-of-type(2){
					width: 100%;
					font-size: 14px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 属性 */
			&-itemAttribute{
				margin:6px 0 0 60px;
				width: 158px;
				height: 80px;
				p{
					width: 100%;
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
				p:nth-of-type(2){
					margin-top: 4px;
				}
			}
			/* 单价 */
			&-itemShopPrice{
				margin:17px 0 0 35px;
				width: 117px;
				font-size: 16px;
				font-weight: 400;
				text-align: center;
				color: #333333;
				letter-spacing: 2px;
			}
			/* 数量 */
			&-itemShopNum{
				margin:17px 0 0 5px;
				width: 70px;
				font-size: 16px;
				font-weight: 400;
				text-align: center;
				color: #333333;
			}
			/* 优惠券 */
			&-itemShopCoupup{
				margin:17px 0 0 63px;
				opacity: 0;
				width: 16px;
				font-size: 16px;
				font-weight: 400;
				color: #818181;
				letter-spacing: 2px;
			}
			/* 快递费 */
			&-itemShopKdF{
				margin: 17px 0 0 62px;
				width: 94px;
				font-size: 16px;
				font-weight: 400;
				text-align: center;
				color: #818181;
				letter-spacing: 2px;
			}
			/* 小计 */
			&-itemShopXj{
				margin: 17px 0 0 38px;
				flex: 1;
				font-size: 16px;
				font-weight: 700;
				text-align: left;
				color: #e62129;
				letter-spacing: 2px;
			}
			/* 总价 */
			&-shopAllPrice{
				width: 100%;
				padding: 20px 48px;
				box-sizing: border-box;
				
				font-size: 16px;
				font-weight: 700;
				text-align: right;
				color: #333333;
			}
		}
	}
	/* 支付标题 */
	.oxqPayTit{
		padding: 40px 0 20px;
		width: 100%;
		
		font-size: 24px;
		font-weight: 400;
		text-align: left;
		color: #000000;
		letter-spacing: 3px;
	}
	/* 支付方式选择 */
	.oxqPayTypeSel{
		width: 100%;
		padding: 30px 40px 24px;
		box-sizing: border-box;
		margin-bottom: 100px;
		background: #FFFFFF;
		li{
			padding: 0 40px;
			box-sizing: border-box;
			img{
				width: 27px;
				height: 24px;
			}
			p{
				margin-left: 20px;
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #000000;
				letter-spacing: 2px;
			}
		}
		li:nth-of-type(1){
			border-right: 2px solid #E1E1E1;
			img{
				width: 24px !important;
				height: 24px !important;
			}
		}
	}
	
</style>
